export default __webpack_public_path__ + "static/media/3.99719548.png";